import React, { useCallback, useState ,useEffect}  from 'react'
import logo from "../../Assets/logo/logo_2x.svg";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { useDispatch, useSelector } from 'react-redux';
import { getUserDetails } from '../../utils/utils';
import Input from '../Input/Index';
import { getProposalDetails } from '../../store/actions/proposalActions';
import { hasPermission } from '../Permissions';

const Header = (props) => {
    const [proposalNumber, setProposalNumber] = useState("");
    const { proposalData } = useSelector((state) => ({
        proposalData: state.proposal.proposalData,
    }));
    const dispatch = useDispatch();
    const logout = () => {
        localStorage.removeItem("userDetails");
        localStorage.removeItem("token");
        localStorage.removeItem("otpValues");
        localStorage.removeItem("envType");
        dispatch({
            type: "USER_LOGOUT"
        })
        window.location.reload();
    }
    useEffect(() => {
        return () => {
            dispatch({
                type: "PROPOSAL_DATA_CLEAR"
            })
        }
    },[])
    const getProposal = useCallback(() => {
        dispatch(getProposalDetails(proposalNumber, (data)=>{
            if(data){
                props.showProposalFunc(true, proposalNumber)
                props.setProposalTab('proposal')
            }
        }))
    }, [proposalNumber, dispatch]);

    const onHandleChange =(name, value, e)=>{
        setProposalNumber(value)
    }
    const handleKeyPress = (event) => {
        if(event.key === "Enter"){
            getProposal()
        }        
      }

    const goToDashboard = ()=>{
        props.setProposalTab('Dashboard')
    }

    const popover = (
        <Popover id="user-menu-popover" className="ops-header-user-popover">
            <Popover.Content className="ops-header-user-popover__content">
                <p className="ops-header-user-popover__item">User Role: {getUserDetails().user.role}</p>
                <p className="ops-header-user-popover__item">Environment: {localStorage?.getItem("envType")}</p>
                <p className="ops-header-user-popover__item ops-header-user-popover__item--logout" onClick={logout}>Logout</p>
            </Popover.Content>
        </Popover>
    );

    return (
        <header className="header-row ops-header" style={{position: "fixed"}}>
            <div className="ops-header__inner main-container">
                <div className="ops-header__left">
                    <button
                        type="button"
                        className={`ops-header__icon-btn ops-header__menu-btn ${props.showMenu ? 'activeHam' : ''}`}
                        onClick={props.toggleMenu}
                        aria-label="Toggle sidebar menu"
                    >
                        <i className="fa fa-bars" aria-hidden="true" />
                    </button>

                    {hasPermission('PROPOSAL_DETAILS') ? (
                        <button
                            type="button"
                            className="ops-header__brand ops-header__brand-btn"
                            onClick={goToDashboard}
                            aria-label="Go to Dashboard"
                        >
                            <img className="ops-header__logo" src={logo} alt="Bharti AXA" />
                        </button>
                    ) : (
                        <div className="ops-header__brand">
                            <img className="ops-header__logo" src={logo} alt="Bharti AXA" />
                        </div>
                    )}
                </div>

                {hasPermission('PROPOSAL_DETAILS') && (
                    <div className="ops-header__search input-text">
                        <Input
                            name="proposalNumber"
                            value={proposalNumber}
                            onChange={(name, value,e) => {onHandleChange(name, value, e)}}
                            placeholder="Enter Proposal Number"
                            showSearchIcon={true}
                            onKeyPress={(e)=>{handleKeyPress(e)}}
                        />
                    </div>
                )}

                <div className="ops-header__right userMenu">
                    <OverlayTrigger trigger="click" placement="bottom-end" rootClose={true} overlay={popover}>
                        <button type="button" className="ops-header__icon-btn ops-header__profile-btn" aria-label="User account menu">
                            <i className="fa fa-user-circle" aria-hidden="true" />
                        </button>
                    </OverlayTrigger>
                </div>
            </div>
        </header>
    )
}

export default Header;
